<script setup>
import { ref, watch } from "vue";
import Dialog from "primevue/dialog";

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  modal: {
    type: Boolean,
    default: true,
  },
  dismissableMask: {
    type: Boolean,
    default: true,
  },
  closable: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(["update:modelValue", "close"]);

const isVisible = ref(props.modelValue);

watch(
  () => props.modelValue,
  (newVal) => {
    isVisible.value = newVal;
  }
);

watch(isVisible, (newVal) => {
  emit("update:modelValue", newVal);
  if (!newVal) {
    emit("close");
  }
});

function handleClose() {
  isVisible.value = false;
}
</script>
<template>
  <Dialog
    v-model:visible="isVisible"
    :modal="modal"
    :dismissable-mask="dismissableMask"
    :closable="closable"
    @hide="handleClose"
  >
    <template #header>
      <slot name="header" />
    </template>

    <slot />

    <template #footer>
      <slot name="footer" />
    </template>
  </Dialog>
</template>
